/**
 * @file main.tab.tsx
 * @description Основная вкладка для формы задачи.
 * Содержит описание задачи с возможностью рич-текст редактирования и сворачиваемых вложений.
 * Поддерживает перетаскивание файлов для загрузки вложений к задаче.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @src/types, @components/form-controls/drag-n-drop-zone, @components/form-controls/collapsed/attachments-rich-text]
 * @related-files [@components/form-controls/drag-n-drop-zone/drag-n-drop.component.tsx, @components/form-controls/collapsed/attachment-list/attachment-list.component.tsx]
 */

import { tabProps } from '@src/types';
import { DragNDropZone } from '@components/form-controls/drag-n-drop-zone';
import { AttachmentsRichText } from '@components/form-controls/collapsed/attachments-rich-text';

export const Main = ({ control }: tabProps) => {
    return (
        <DragNDropZone className="flex flex-col h-full gap-[1.0585vmin]" name="attachments" control={control}>
            <AttachmentsRichText
                label="Описание"
                name="description"
                control={control}
                placeholder="Добавьте описание задачи, чтобы исполнителю было понятно, что нужно сделать в рамках задачи"
            />
        </DragNDropZone>
    );
};
